module.exports = __webpack_public_path__ + "img/switzerland-digestive-diseases-male.0ff7f3c0.png";